module.exports = __webpack_public_path__ + "assets/img/sliderItem3.56f0cb53.png";